export default __webpack_public_path__ + "static/media/error.f5e8f8bc.jpg";